module.exports = __webpack_public_path__ + "media/images/bestballzone-af46f800.jpg";